import { z } from "zod";

export const sectorSchema = () => {
  return z.object({
    name: z.string().min(1),
    type: z.string().min(1),
  });
};

export type SectorFormValues = z.infer<ReturnType<typeof sectorSchema>>;
